import { CustomerEnquiryEntity, EMPTY_CUSTOMER_ENQUIRY_ENTITY } from "domain/entity/CustomerEnquiry/CustomerEnquiryEntity";
import { CustomerEnquirySearchCriteria, EMPTY_CUSTOMER_ENQUIRY_SEARCH_CRITERIA } from "presentation/constant/CustomerEnquiry/CustomerEnquirySearchCriteria";
import { BaseViewChangeSate } from "../BaseViewChangeState";
import { DropdownProps } from "../DropdownProps";

export interface CustomerEnquiryDropdownOptions {
    companyCodeDropdownOptions: DropdownProps[],
    customerCodeDropdownOptions: DropdownProps[],
    customerTypeDropdownOptions: DropdownProps[],
}
export interface CustomerEnquiryViewChangeState extends BaseViewChangeSate {
}

export interface CustomerEnquiryModel {
    isLoading: boolean,
    isShowEditPanel: boolean,
    isShowSearchPanel: boolean,
    isAdd: boolean,
    isEdit: boolean,
    dynamicOptions: CustomerEnquiryDropdownOptions,
    customerEnquiryList: CustomerEnquiryEntity[],
    selectedRows: CustomerEnquiryEntity[],
    updatedRows: CustomerEnquiryEntity[],
    currentRow: CustomerEnquiryEntity,
    currentEditRow: CustomerEnquiryEntity,
    searchCriteria: CustomerEnquirySearchCriteria,
    isAllowAutoSearch: boolean,
}

export const EMPTY_CUSTOMER_ENQUIRY_MODEL: CustomerEnquiryModel = {
    isLoading: false,
    isShowEditPanel: false,
    isAdd: false,
    isEdit: false,
    isShowSearchPanel: false,
    dynamicOptions: {
        companyCodeDropdownOptions: [],
        customerCodeDropdownOptions: [],
        customerTypeDropdownOptions: [],
    },
    customerEnquiryList: [],
    selectedRows: [],
    updatedRows: [],
    currentRow: { ...EMPTY_CUSTOMER_ENQUIRY_ENTITY },
    currentEditRow: { ...EMPTY_CUSTOMER_ENQUIRY_ENTITY },
    searchCriteria: EMPTY_CUSTOMER_ENQUIRY_SEARCH_CRITERIA,
    isAllowAutoSearch: true,
}